__turbopack_context__.v({
  "image": "DiscountCatalogItem-module-scss-module__iWFWra__image",
  "item": "DiscountCatalogItem-module-scss-module__iWFWra__item",
  "modal": "DiscountCatalogItem-module-scss-module__iWFWra__modal",
  "modalContent": "DiscountCatalogItem-module-scss-module__iWFWra__modalContent",
  "price": "DiscountCatalogItem-module-scss-module__iWFWra__price",
  "priceBlock": "DiscountCatalogItem-module-scss-module__iWFWra__priceBlock",
  "props": "DiscountCatalogItem-module-scss-module__iWFWra__props",
  "tags": "DiscountCatalogItem-module-scss-module__iWFWra__tags",
  "title": "DiscountCatalogItem-module-scss-module__iWFWra__title",
  "titleMobile": "DiscountCatalogItem-module-scss-module__iWFWra__titleMobile",
});
